import { VirtualExperienceTopicsMenuItems } from './virtual-experience-topics-menu-item';
import { Button } from '@cue/atoms';
import { useHash } from '@cue/hooks';
import { Tabs } from '@cue/molecules';
import { IVideoStateHandler } from '@cuevideostory/core';
import { ShowroomTopics } from '@project/cue-api/virtual-experience/fetch-video-story-topics';
import React, { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const VirtualExperienceTopicsMenu = forwardRef(function VirtualExperienceTopicsMenu(
  props: VirtualExperienceTopicsMenuProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { hash, updateHash } = useHash();
  const {
    videoTopicsJSON,
    visible,
    onHideMenu,
    stateHandler = {
      setState: updateHash,
      state: hash,
    },
  } = props;

  const {
    i18n: { language },
  } = useTranslation();

  const masterTopics = useMemo(
    () =>
      videoTopicsJSON?.map((topic) => {
        return {
          title: topic.translations?.find((trans) => trans.language === language)?.title || '',
          item: (
            <VirtualExperienceTopicsMenuItems
              stateHandler={stateHandler}
              topics={topic?.topics}
              onHideMenu={onHideMenu}
              // TODO
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              //@ts-ignore

              containerRef={ref?.current}
            />
          ),
        };
      }),
    [language, onHideMenu, ref, stateHandler, videoTopicsJSON],
  );

  return (
    <div
      className={`cue-video-story-topics-menu ? ${
        visible ? 'cue-video-story-topics-menu-visible' : ''
      }`}
      ref={ref}>
      <div className="cue-video-story-topics-menu-close">
        <Button icon="close" styling="modalClosePlain" onClick={onHideMenu} />
      </div>
      <Tabs items={masterTopics} />
    </div>
  );
});

interface VirtualExperienceTopicsMenuProps {
  videoTopicsJSON: ShowroomTopics[];
  visible: boolean;
  stateHandler: IVideoStateHandler;
  onHideMenu(): void;
}
